const docControl = {
  overview: "סקירה",
  viewHistory: "היסטוריית צפיות",
  fieldLocks: "שדות נעולים",
  messages: "הודעות",
  auditLog: "לוג פעולות",
  notFound: "מסמך לא נמצא",
  backToList: "חזרה לרשימה",
  liveViewing: "צופים עכשיו",
  submitters: "חותמים",
  totalViews: "צפיות",
  lockedFields: "שדות נעולים",
  unreadMessages: "הודעות שלא נקראו",
  documentInfo: "פרטי מסמך",
  created: "נוצר",
  sentAt: "נשלח",
  signedAt: "נחתם",
  expiresAt: "תוקף",
  cancelledAt: "בוטל",
  pdfHash: "חתימת PDF",
  unnamed: "ללא שם",
  role_signer: "חותם",
  role_witness: "עד",
  role_approver: "מאשר",
  actions: "פעולות",
  markSent: "סמן כנשלח",
  cancel: "בטל מסמך",
  archive: "העבר לארכיון",
  statusDraft: "טיוטה",
  statusSent: "נשלח",
  statusViewed: "נצפה",
  statusPartial: "חתום חלקי",
  statusSigned: "חתום",
  statusExpired: "פג תוקף",
  statusCancelled: "בוטל",
  statusArchived: "ארכיון",
  noViews: "אין צפיות עדיין",
  duration: "משך",
  noLocks: "אין שדות נעולים",
  lockedBy: "ננעל ע\"י",
  unlock: "שחרר",
  noMessages: "אין הודעות",
  internal: "פנימי",
  submitterMsg: "חותם",
  typeMessage: "הקלד הודעה...",
  noAudit: "אין רשומות",
  checklist: "צ'ק ליסט",
  noChecklist: "אין פריטי צ'ק ליסט",
  required: "חובה",
  acceptedTypes: "סוגים מותרים",
  maxSize: "מקסימום",
  uploadFile: "העלה קובץ",
  uploadAnother: "העלה נוסף",
  approve: "אשר",
  reject: "דחה",
  rejectReason: "סיבת דחייה...",
  cancelAction: "ביטול",
  review_pending: "ממתין",
  review_approved: "אושר",
  review_rejected: "נדחה",
  downloadPdf: "הורד PDF",
  generateAndStore: "צור ושמור PDF",
  signers: "חותמים",
  addSigner: "הוסף חותם",
  noSigners: "לא נוספו חותמים עדיין",
  sendForSigning: "שלח לחתימה",
  sendForSigningDesc: "צור קישור חתימה ושלח למסמך",
  sendNow: "שלח עכשיו",
  signingLink: "קישור חתימה",
  copyLink: "העתק",
  copied: "הועתק!",
  documentSentInfo: "המסמך נשלח לחתימה",
  fullName: "שם מלא",
  emailAddress: "אימייל",
  phoneNumber: "טלפון",
  edit: "ערוך",
  delete: "מחק",
  save: "שמור",
  declined: "סורב",
  fieldValues: "ערכי שדות",
  contentPreview: "תוכן המסמך",
  showLess: "הצג פחות",
  showMore: "הצג עוד",
  moreLines: "שורות נוספות",
  resendLink: "שלח שוב",
  sendReminder: "תזכורת",
  revokeDocument: "בטל שליחה",
  editContent: "עריכת תוכן",
  editWarning: "המסמך כבר נשלח — עריכה אפשרית רק בטיוטות",
  noFieldValues: "אין ערכי שדות",
  fieldsReadOnly: "שדות לקריאה בלבד — עריכה אפשרית רק בטיוטות",
} as const;
export default docControl;
